import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '@core/services';
import { BaseComponent } from '@modules/components';
import { SISTEK_EMAIL_PATTERN } from '@modules/validators/patterns';
import { takeUntil } from 'rxjs';
import { RegisterExpired } from '../models/register-expired';
import { RegisterExpiredService } from '../services/register-expired.service';

@Component({
	selector: 'register-expired',
	templateUrl: './register-expired.component.html',
	styleUrls: ['./register-expired.component.scss'],
	standalone: false,
})
export class RegisterExpiredComponent extends BaseComponent implements OnInit {
	activationKey: string;

	constructor(
		private activatedRoute: ActivatedRoute,
		private registerExpiredService: RegisterExpiredService,
		private router: Router,
		utilServ: UtilityService
	) {
		super(null, utilServ);
		this.form = this.builder.group({
			email: ['', [Validators.email, Validators.required, Validators.pattern(SISTEK_EMAIL_PATTERN)]],
		});
	}

	ngOnInit(): void {
		this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(({ activation }) => {
			this.activationKey = activation;
		});
		this.hideloader();
	}

	public onSubmit(): void {
		this.showLoader();
		if (this.form.valid) {
			const { email } = this.form.value;

			const model: RegisterExpired = {
				key: this.activationKey,
				email: email,
			};

			this.registerExpiredService.resendActivationLink(model).subscribe(() => {
				this.utilServ.alertService.success(this.t('alert.title.success'), this.t('alert.message.reactivation-message'));
				this.hideloader();
				this.router.navigateByUrl('/login');
			});
		}
	}
}
